import { useEffect, useState } from "react";
import { IUser } from "utils/types";
import useAzureToken from "./useAzureToken";

export default function useSessionUser() {
  const [user, setUser] = useState<IUser>();
  const token = useAzureToken();

  useEffect(() => {
    function getUser() {
      fetch(
        `${import.meta.env.REACT_APP_API_URL}/api/users/me`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      )
        .then((response) => {
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }
          return response.json();
        })
        .then((userJson: IUser) => {
          setUser(userJson);
        })
        .catch((error) => {
          console.error('Error fetching user data:', error);
        });
    }

    if (token) {
      getUser();
    }
  }, [token]);

  return { user, token };
}